module.exports = __webpack_public_path__ + "img/loginpwd.8787f08c.svg";